import { render, staticRenderFns } from "./ProblemsPanel.vue?vue&type=template&id=4c025da0&scoped=true&"
import script from "./ProblemsPanel.vue?vue&type=script&lang=js&"
export * from "./ProblemsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProblemsPanel.vue?vue&type=style&index=0&id=4c025da0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c025da0",
  null
  
)

export default component.exports